export default "__VITE_PUBLIC_ASSET__9beabc6d__"